import styled from 'styled-components'

const BaseRow = styled.div`
    display: grid;
    grid-template-columns: 0.1fr 1.5fr 1fr 1fr 1.5fr 1.5fr 1fr 0.5fr 0.5fr 0.5fr 1fr 1fr;

    & > * {
        padding: 16px;
    }
`

export const HeadRow = styled(BaseRow)`
    border-bottom: 1px solid ${({ theme }) => theme['light-borders']};
    color: ${({ theme }) => theme.gray};
    font-family: ${({ theme }) => theme['font-semibold']};
    font-size: 13px;
    user-select: none;
    text-transform: uppercase;

    & > * {
        align-items: center;
        display: flex;
    }
`

export const BodyRow = styled(BaseRow)`
    border-bottom: 1px solid ${({ theme }) => theme['full-page-background']};
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
    }

    .file-name {
        font-weight: bold;
        padding-right: 30px;
        text-transform: uppercase;
    }

    .info-icon {
        position: relative;
        //display: inline-block;
    }

    .tooltip {
        position: absolute;
        top: 0;
        left: 50%;
        background-color: var("--gray-500");
        color: #fff;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 14px;
        white-space: nowrap; /* Prevent line breaks */
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .fa-ul {
        list-style: circle;
        margin: 0;
        padding: 0;
    }

    .fa-ul li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.1rem;
    }

}
`

export const Table = styled.div`
    margin-bottom: 32px;
`

export const NoData = styled.div`
    color: #999;
    font-size: 18px;
    text-align: center;
    margin-top: 20px;
`

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    & > *:not(:last-child) {
        margin-right: 10px;
    }
`

export const DeleteButton = styled.button`
    padding: 10px 10px;
    background-color: #dc3545; /* Red color for delete */
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    text-align: center; /* Center-align text */

    &:hover {
        background-color: #c82333; /* Darker red for hover */
    }
`

export const FileInputButton = styled.label`
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    width: 150px; /* Set a fixed width */
    text-align: center; /* Center-align text */

    &:hover {
        background-color: #0056b3;
    }

    input {
        display: none;
    }
`

export const RemapButton = styled.button`
    padding: 10px 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    text-align: center; /* Center-align text */

    &:hover {
        background-color: #0056b3;
    }
`
